import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ImageModule } from '@df/module-image/image.module';
import { ColorOptions, MarginRightOptions, TextStyleOptions } from '@df/ui/atomic/atomic-options';
import { DragScrollDirective } from '@df/ui/common/drag-scroll.directive';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
interface IQuickLinksBlockData extends NICmsContentComponent.IData {
    quick_link_type: string;
    text_color: string;
    text_font_style: string;
    quick_link_margin: string;
    quick_links?: IQuickLink[];
}
interface IQuickLink {
    image?: string;
    text: string;
    url: string;
}
export const fields = [
    <NICmsContentField.IChoiceField>{
        type: NICmsContentField.EFieldType.choice,
        title: 'Quick link type',
        key: 'quick_link_type',
        required: true,
        options: [
            { key: 'link', title: 'Link' },
            { key: 'image', title: 'Image' }
        ],
        default: 'link'
    },
    <NICmsContentField.IChoiceField>{
        key: 'text_color',
        type: NICmsContentField.EFieldType.choice,
        title: 'Quick link colour',
        options: ColorOptions,
        previewMode: 'color',
        required: true,
        default: 'col-1'
    },
    <NICmsContentField.IChoiceField>{
        key: 'text_font_style',
        type: NICmsContentField.EFieldType.choice,
        title: 'Quick link font style',
        options: TextStyleOptions,
        required: true,
        default: 'p2'
    },
    <NICmsContentField.IChoiceField>{
        key: 'quick_link_margin',
        type: NICmsContentField.EFieldType.choice,
        title: 'Quick link margin',
        options: MarginRightOptions,
        required: true,
        default: 'm-r-4'
    },
    <NICmsContentField.IRepeaterField>{
        type: NICmsContentField.EFieldType.repeater,
        key: 'quick_links',
        title: 'Quick Links',
        default: [],
        itemName: 'Quick link',
        itemNameField: 'text',
        fields: [
            {
                title: 'Image',
                key: 'image',
                type: NICmsContentField.EFieldType.image
            },
            <NICmsContentField.IField>{
                type: NICmsContentField.EFieldType.text,
                key: 'text',
                title: 'Text',
                required: true
            },
            <NICmsContentField.IField>{
                type: NICmsContentField.EFieldType.text,
                key: 'url',
                title: 'Url',
                required: true
            }
        ],
        canShow: data => data?.quick_link_type === 'image'
    },
    <NICmsContentField.IRepeaterField>{
        type: NICmsContentField.EFieldType.repeater,
        key: 'quick_links',
        title: 'Quick Links',
        itemName: 'Quick link',
        itemNameField: 'text',
        fields: [
            <NICmsContentField.IField>{
                type: NICmsContentField.EFieldType.text,
                key: 'text',
                title: 'Text',
                required: true
            },
            <NICmsContentField.IField>{
                type: NICmsContentField.EFieldType.text,
                key: 'url',
                title: 'Url',
                required: true
            }
        ],
        default: [
            {
                text: 'Close Contact',
                url: '/horse-saddle-pads/close-contact-pads'
            },
            {
                text: 'General Purpose ',
                url: '/horse-saddle-pads/gp-pads'
            },
            {
                text: 'Dressage',
                url: '/horse-saddle-pads/dressage-pads'
            },
            {
                text: 'Show Jumping',
                url: '/horse-saddle-pads/show-jumping-pads'
            },
            {
                text: 'Numnahs',
                url: '/horse-saddle-pads/numnahs'
            },
            {
                text: 'Pony',
                url: '/horse-saddle-pads/pony-saddle-pads'
            },
            {
                text: 'Corrective',
                url: '/horse-saddle-pads/corrective-pads'
            },
            {
                text: 'Showing',
                url: '/horse-saddle-pads/showing-pads'
            },
            {
                text: 'Half Pads',
                url: '/horse-saddle-pads/half-pads'
            }
        ],
        canShow: data => data?.quick_link_type == 'link'
    }
];
@ICmsComponent<PageComponentQuickLinksComponent>({
    id: 'quick-links',
    name: 'Quick Links',
    tags: ['listing', 'category', 'carousel'],
    fields
})
@Component({
    selector: 'page-component-quick-links',
    templateUrl: './quick-links.html',
    styleUrls: ['./quick-links.scss'],
    standalone: true,
    imports: [DragScrollDirective, HrefComponent, NgClass, ImageModule, ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageComponentQuickLinksComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: IQuickLinksBlockData;

}
